import React, { useRef } from 'react';
import Select from 'react-select';

const normalizeString = (str) => {
    if (typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};

const filterOption = (option, inputValue) => {
    const normalizedLabel = normalizeString(option.label);
    const normalizedInput = normalizeString(inputValue);
    return normalizedLabel.includes(normalizedInput);
};

export const AutocompleteSelect = ({
    blank,
    field,
    firstOption,
    displayAttribute,
    itemRow,
    inputClass,
    notNull,
    noBlankOption,
    emptyOption,
    onlyvalid,
    selectedValue,
    disabled,
    helperItem,
    ...props
}) => {
    const selectRef = useRef(null);

    let options = [];

    if (helperItem) {
        options.push({ value: -2, label: ' \u00A0 ' });
    }

    if (!noBlankOption) {
        options.push({ value: '', label: '---' });
    }

    props.data.forEach(item => {
        const id = item?.id ?? item?.slug ?? item;
        const display =
            (item && item[displayAttribute || 'title']) ||
            item ||
            blank;
        options.push({ value: id, label: display });
    });

    const customStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
            fontSize: 'var(--s)',
        }),

        control: (base, state) => ({
            ...base,
            border: `0px solid ${
                state.isDisabled ? 'var(--semidark)' : 'var(--primary)'
            }`,
            //padding: '0.3rem 0.75rem',
            backgroundColor: 'white',
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            boxShadow: 'none',
            minHeight: 'unset',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',

            '&:hover': {
                borderColor: state.isDisabled
                    ? 'var(--semidark)'
                    : 'var(--primary)',
            },
        }),

        valueContainer: (base) => ({
            ...base,
            padding: 0,
            overflow: 'hidden',
        }),

        singleValue: (base, state) => ({
            ...base,
            color: state.isDisabled
                ? 'var(--semidark)'
                : itemRow? 'var(--purple)':'black',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            border:"0px solid red",
            height:itemRow?"1.5rem":"",
            fontSize: itemRow?"var(--xs)":"",
            paddingTop: itemRow?"0.5rem":"",
            textOverflow: 'ellipsis',
            pointerEvents: 'none',
            fontWeight: 400, 
        }),

        placeholder: (base, state) => ({
            ...base,
            color: state.isDisabled
                ? 'var(--semidark)'
                : 'var(--primary)',
        }),

        indicatorSeparator: () => ({
            display: 'none',
        }),

        dropdownIndicator: (base, state) => ({
            ...base,
            padding: 0,
            //marginLeft: '0.5rem',
            color: state.isDisabled
                ? 'var(--semidark)'
                : 'var(--primary)',
            fontSize: '0.7rem',
            transition: 'transform 0.2s ease',
            transform: state.selectProps.menuIsOpen
                ? 'rotate(180deg)'
                : 'rotate(0deg)',
        }),

        menu: (base) => ({
            ...base,
            marginTop: '0.25rem',
            border: '1px solid var(--primary)',
            borderRadius: '10px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
            overflow: 'hidden',
            zIndex: 1000,

            width: 'max-content',
            minWidth: '100%',
            maxWidth: '15rem',
        }),

        menuList: (base) => ({
            ...base,
            maxHeight: '16rem',
            padding: 0,
        }),

        option: (base, state) => ({
            ...base,
            padding: '0.5rem 1rem',
            fontSize: 'var(--s)',
            color: state.isSelected ? 'var(--purple)' : 'var(--purple)',
            backgroundColor: state.isSelected
                ? 'rgba(0, 0, 0, 0.03)'
                : state.isFocused
                ? 'var(--primarylight)'
                : 'white',
            cursor: 'pointer',
            fontWeight: state.isSelected ? 500 : 'normal',
            borderBottom: '1px solid rgba(0,0,0,0.05)',

            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',

            ':active': {
                backgroundColor: 'var(--primarylight)',
            },
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    return (
        <Select
            ref={selectRef}
            options={options}
            value={options.find(
                option => option.value === selectedValue
            )}
            isDisabled={disabled}
            onChange={(selectedOption) => {
                if (props.onChange) {
                    props.onChange(selectedOption?.value);
                }
            }}
            styles={customStyles}
            menuPortalTarget={document.body}
            placeholder="---"
            noOptionsMessage={() => 'Žádné'}
            filterOption={filterOption}
            menuPlacement="auto"
        />
    );
};
